"use strict";
/*
  This file is part of web3x.

  web3x is free software: you can redistribute it and/or modify
  it under the terms of the GNU Lesser General Public License as published by
  the Free Software Foundation, either version 3 of the License, or
  (at your option) any later version.

  web3x is distributed in the hope that it will be useful,
  but WITHOUT ANY WARRANTY; without even the implied warranty of
  MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
  GNU Lesser General Public License for more details.

  You should have received a copy of the GNU Lesser General Public License
  along with web3x.  If not, see <http://www.gnu.org/licenses/>.
*/
Object.defineProperty(exports, "__esModule", { value: true });
var ws_1 = require("./ws");
exports.WebsocketProvider = ws_1.WebsocketProvider;
var http_1 = require("./http");
exports.HttpProvider = http_1.HttpProvider;
var ipc_1 = require("./ipc");
exports.IpcProvider = ipc_1.IpcProvider;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoibGVnYWN5LXByb3ZpZGVyLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vc3JjL3Byb3ZpZGVycy9sZWdhY3ktcHJvdmlkZXIudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IjtBQUFBOzs7Ozs7Ozs7Ozs7Ozs7RUFlRTs7QUFFRiwyQkFBeUM7QUFBaEMsaUNBQUEsaUJBQWlCLENBQUE7QUFDMUIsK0JBQXNDO0FBQTdCLDhCQUFBLFlBQVksQ0FBQTtBQUNyQiw2QkFBb0M7QUFBM0IsNEJBQUEsV0FBVyxDQUFBIn0=